import { useState } from "react";
import { getBizType, THEME, vibrate, playSound } from "../utils/helpers";

export default function PinLock({ correctPin, onSuccess, onBack, color }) {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState(false);
  const biz = getBizType(color);
  const c = biz?.color || THEME.gold;

  const check = (p) => {
    if (p.length === 4) {
      if (p === correctPin) {
        playSound("success");
        vibrate([50, 30, 50]);
        onSuccess();
      } else {
        playSound("error");
        vibrate([100, 50, 100, 50, 100]);
        setErr(true); setPin("");
        setTimeout(() => setErr(false), 1200);
      }
    }
  };

  const tap = (n) => {
    vibrate([20]);
    if (n === "del") { setPin((p) => p.slice(0, -1)); return; }
    if (pin.length < 4) {
      const next = pin + n;
      setPin(next);
      if (next.length === 4) setTimeout(() => check(next), 150);
    }
  };

  return (
    <div style={{
      height: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: "#111", color: "#fff",
    }}>
      <button onClick={onBack} style={{
        position: "absolute", top: 20, left: 20,
        background: "rgba(255,255,255,0.1)", border: "none",
        color: "#fff", borderRadius: 10, padding: "8px 14px",
        fontSize: 13, cursor: "pointer", fontWeight: 600,
      }}>← Retour</button>

      <div style={{ fontSize: 52, marginBottom: 20, animation: err ? "shake 0.4s ease" : "none" }}>🔒</div>
      <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 24 }}>Code PIN</div>

      <div style={{ display: "flex", gap: 16, marginBottom: 30 }}>
        {[0,1,2,3].map((i) => (
          <div key={i} style={{
            width: 18, height: 18, borderRadius: "50%",
            background: err ? THEME.red : pin.length > i ? c : "#333",
            transition: "all 0.2s ease",
            boxShadow: pin.length > i ? `0 0 12px ${c}66` : "none",
          }} />
        ))}
      </div>

      {err && <div style={{ color: THEME.red, fontSize: 14, fontWeight: 700, marginBottom: 16, animation: "fadeUp 0.3s ease" }}>Code incorrect !</div>}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 70px)", gap: 12 }}>
        {[1,2,3,4,5,6,7,8,9,null,0,"del"].map((n, i) => (
          n !== null ? (
            <button key={i} onClick={() => tap(n)} style={{
              width: 70, height: 70, borderRadius: "50%",
              background: n === "del" ? "transparent" : "#222",
              border: n === "del" ? "none" : "1px solid #333",
              color: "#fff", fontSize: n === "del" ? 22 : 26, fontWeight: 700,
              cursor: "pointer", transition: "all 0.1s ease",
            }}
            onMouseDown={(e) => { if (n !== "del") e.currentTarget.style.background = c; }}
            onMouseUp={(e) => { if (n !== "del") e.currentTarget.style.background = "#222"; }}
            >{n === "del" ? "⌫" : n}</button>
          ) : <div key={i} />
        ))}
      </div>
    </div>
  );
}
